import type { ReactNode } from 'react';
import styles from './CardBulb.module.css';

export interface ICardBulbProps {
  label: string;
  children: ReactNode;
}

export function CardBulb({ label, children }: ICardBulbProps) {
  return (
    <div className={styles.bulb}>
      <div className={styles.header}>
        <span className={styles.headerLabel}>{label}</span>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
